<script setup lang="ts">
import type { TriangleVariants } from '.';
import type { PrimitiveProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { Primitive } from 'reka-ui';
import { ref } from 'vue';

import { triangleVariants } from '.';

interface Props extends PrimitiveProps {
	stroke?: TriangleVariants['stroke'];
	class?: HTMLAttributes['class'];
	isStrokeApplied?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	as: 'svg',
	class: '',
	stroke: 'black',
	isStrokeApplied: false
});

const pathRef = ref<HTMLElement>();

const initialStrokeDashoffset = computed(() =>
	props.isStrokeApplied ? 0 : 100
);

function applyAnimation(_variant: 'strokeFormation' = 'strokeFormation') {
	if (typeof pathRef.value?.animate !== 'function') return;
	pathRef.value.animate(
		[
			{ strokeDashoffset: String(initialStrokeDashoffset.value) },
			{ strokeDashoffset: '0' }
		],
		{
			duration: 2000,
			easing: 'cubic-bezier(0.35, 0.17, 0.3, 0.86)',
			fill: 'forwards'
		}
	);
}

defineExpose({
	pathRef,
	applyAnimation
});
</script>

<template>
	<Primitive
		:as="as"
		:as-child="asChild"
		:class="cn(triangleVariants({ stroke }), props.class)"
		viewBox="0 0 26 28"
	>
		<path
			ref="pathRef"
			:class="{ '[stroke-dashoffset:0]': isStrokeApplied }"
			class="fill-current"
			d="M22.7026 28L0 14.9304L25.9339 0L22.7026 28Z"
		/>
	</Primitive>
</template>
